import styled from 'styled-components/macro';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #000;
  z-index: 9999;
  display: flex;
  flex-direction: column;
`;

export const VideoWrapper = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  cursor: ${({ showControls }) => (showControls ? 'default' : 'none')};
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  opacity: ${({ show }) => (show ? '1' : '0')};
  pointer-events: ${({ show }) => (show ? 'all' : 'none')};

  &:hover {
    background: rgba(229, 9, 20, 0.9);
    transform: scale(1.05);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Controls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 70%, transparent 100%);
  padding: 60px 40px 20px;
  transition: all 0.3s ease;
  opacity: ${({ show }) => (show ? '1' : '0')};
  pointer-events: ${({ show }) => (show ? 'all' : 'none')};
  z-index: 5;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 5px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  cursor: pointer;
  margin-bottom: 20px;
  position: relative;
  transition: height 0.2s ease;
  overflow: visible;

  &:hover {
    height: 8px;
  }
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: #e50914;
  border-radius: 2px;
  width: ${({ progress }) => progress}%;
  position: relative;
  transition: width 0.1s linear;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 14px;
    background: #e50914;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  ${ProgressBarContainer}:hover &::after {
    opacity: 1;
  }
`;

export const BufferedBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
  width: ${({ buffered }) => buffered}%;
  transition: width 0.3s ease;
`;

export const ViewDensityBar = styled.svg`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  pointer-events: none;
  overflow: visible;

  path {
    fill: rgba(255, 255, 255, 0.3);
    transition: fill 0.2s ease, opacity 0.2s ease;
    opacity: 0.8;
  }

  ${ProgressBarContainer}:hover & {
    height: 50px;
  }

  ${ProgressBarContainer}:hover & path {
    fill: rgba(255, 255, 255, 0.5);
    opacity: 1;
  }
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const ControlsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const ControlsRight = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const ControlButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 50%;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
  }

  svg {
    width: 28px;
    height: 28px;
  }

  &.play-pause svg {
    width: 36px;
    height: 36px;
  }
`;

export const TimeDisplay = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  user-select: none;
`;

export const VolumeControl = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
`;

export const VolumeSlider = styled.input`
  width: 0;
  opacity: 0;
  transition: all 0.3s ease;
  -webkit-appearance: none;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;

  ${VolumeControl}:hover & {
    width: 80px;
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    background: #e50914;
    cursor: pointer;
    border-radius: 50%;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    background: #e50914;
    cursor: pointer;
    border-radius: 50%;
    border: none;
  }
`;

export const Title = styled.div`
  position: absolute;
  top: 80px;
  left: 40px;
  color: white;
  z-index: 10;
  opacity: ${({ show }) => (show ? '1' : '0')};
  transition: opacity 0.3s ease;
  pointer-events: none;

  h1 {
    font-size: 32px;
    font-weight: 700;
    margin: 0 0 10px 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  }

  p {
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    color: rgba(255, 255, 255, 0.8);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  }
`;

export const LoadingSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top-color: #e50914;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  z-index: 10;

  @keyframes spin {
    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
`;

export const SettingsButton = styled(ControlButton)`
  position: relative;
`;

export const SettingsMenu = styled.div`
  position: absolute;
  bottom: 100%;
  right: 0;
  background: rgba(0, 0, 0, 0.95);
  border-radius: 4px;
  padding: 10px 0;
  margin-bottom: 10px;
  min-width: 200px;
  opacity: ${({ show }) => (show ? '1' : '0')};
  pointer-events: ${({ show }) => (show ? 'all' : 'none')};
  transform: ${({ show }) => (show ? 'translateY(0)' : 'translateY(10px)')};
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const SettingsItem = styled.div`
  padding: 12px 20px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &.active {
    color: #e50914;
    font-weight: 600;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ show }) => (show ? '1' : '0')};
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 3;
`;

export const PlayPauseIcon = styled.div`
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 40px;
    height: 40px;
    color: white;
  }
`;
